import { render } from "./User.vue?vue&type=template&id=0079ffa2"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./User.vue?vue&type=style&index=0&id=0079ffa2&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script